import { bootstrapResponsiveBreakpoints } from '@teetsh/app/src/utils/constants';
import { useMediaQuery } from 'react-responsive';

// J'utilise ici plutôt une lib car lorsque j'utilisais un hook mais ça renvoyait true puis false
// Donc si un jour tu changes ça tu check que ça te fait bien un seul render avec tout de suite la bonne valeur
// Car sinon ça peut poser problème avec le SEO (layout shift)
// En gros sur la page présentant des programmations, google prenait en compte le 1er render
// Donc celui avec la programmation qui avait opti pour écran large et pas la version mobile
const useIsBelowSize = (size: number): boolean =>
  useMediaQuery({ maxWidth: size });

// Tailwind avec "md" va cibler tout ce qui est >= 768px
// -> un bouton avec "md:hidden" sera donc donc masqué dès 768px
// Sachant cela, pour que nos différentes conditions se complètent bien,
// on doit donc vérifier que la taille d'écran est bien strictement inférieure,
// d'où le "- 1" permettant d'exclure la valeur exacte
export const useIsBelowBreakpoint = (breakpoint: any): boolean =>
  useMediaQuery({ maxWidth: bootstrapResponsiveBreakpoints[breakpoint] - 1 });

export const useIsBelowHeight = (height: number): boolean =>
  useMediaQuery({ maxHeight: height });

export default useIsBelowSize;
